import logo1 from "../assets/images/blueocean.svg"
import logo2 from "../assets/images/minos.svg"
import logo3 from "../assets/images/cronos.svg"
import logo4 from "../assets/images/funda.svg"
import logo5 from "../assets/images/360TradeHub.svg"
import logo6 from "../assets/images/antos.svg"
import logo7 from "../assets/images/equinox.svg"
import logo8 from "../assets/images/excotrade.svg"

const Keys = {
    // brandName: "Blue Ocean",
    // API_URL:"https://cmsapi.blueoceanfin.com",
    // SERVER_URL:"https://cmsapi.blueoceanfin.com",
    // MEDIA_URL:"https://cmsapi.blueoceanfin.com/media/",
    // LOGO: logo1,
    // LOGO_CLASSNAME: "blueocean-logo",

    // brandName: "Blue Ocean",
    // API_URL:"https://cmsapi.blueocex.com",
    // SERVER_URL:"https://cmsapi.blueocex.com",
    // MEDIA_URL:"https://cmsapi.blueocex.com/media/",
    // LOGO: logo1,
    // LOGO_CLASSNAME: "blueocean-logo",

    // brandName: "Minos Futures",
    // API_URL: "https://cmsapi.minosfutures.com",
    // SERVER_URL: "https://cmsapi.minosfutures.com",
    // MEDIA_URL: "https://cmsapi.minosfutures.com/media/",
    // LOGO: logo2,
    // LOGO_CLASSNAME: "minos-logo",

    // brandName: "Cronos",
    // API_URL:"https://cmsapi.cronoscap.com",
    // SERVER_URL:"https://cmsapi.cronoscap.com",
    // MEDIA_URL:"https://cmsapi.cronoscap.com/media/",
    // LOGO: logo3,
    // LOGO_CLASSNAME: "cronos-logo",

    // brandName: "Cronos",
    // API_URL:"https://cmsapi.cronoscap.net",
    // SERVER_URL:"https://cmsapi.cronoscap.net",
    // MEDIA_URL:"https://cmsapi.cronoscap.net/media/",
    // LOGO: logo3,
    // LOGO_CLASSNAME: "cronos-logo",

    // brandName: "Funda Markets",
    // API_URL:"https://cmsapi.fundamarkets.net",
    // SERVER_URL:"https://cmsapi.fundamarkets.net",
    // MEDIA_URL:"https://cmsapi.fundamarkets.net/media/",
    // LOGO: logo4,
    // LOGO_CLASSNAME: "funda-logo",

    // brandName: "Funda Markets",
    // API_URL:"https://cmsapi.fundamarkets.com",
    // SERVER_URL:"https://cmsapi.fundamarkets.com",
    // MEDIA_URL:"https://cmsapi.fundamarkets.com/media/",
    // LOGO: logo4,
    // LOGO_CLASSNAME: "funda-logo",

    // brandName: "360tradehub",
    // API_URL:"https://cmsapi.360tradehub.com",
    // SERVER_URL:"https://cmsapi.360tradehub.com",
    // MEDIA_URL:"https://cmsapi.360tradehub.com/media/",
    // LOGO: logo5,
    // LOGO_CLASSNAME: "tradehub360-logo",

    // brandName: "360tradehub",
    // API_URL:"https://cmsapi.tradehub360.com",
    // SERVER_URL:"https://cmsapi.tradehub360.com",
    // MEDIA_URL:"https://cmsapi.tradehub360.com/media/",
    // LOGO: logo5,
    // LOGO_CLASSNAME: "tradehub360-logo",

    brandName: "Antospnc",
    API_URL:"https://cmsapi.antospnc.com",
    SERVER_URL:"https://cmsapi.antospnc.com",
    MEDIA_URL:"https://cmsapi.antospnc.com/media/",
    LOGO: logo6,
    LOGO_CLASSNAME: "antos-logo",

    // brandName: "Antos",
    // API_URL:"https://cmsapi.antos.io",
    // SERVER_URL:"https://cmsapi.antos.io",
    // MEDIA_URL:"https://cmsapi.antos.io/media/",
    // LOGO: logo6,
    // LOGO_CLASSNAME: "antos-logo",

    // brandName: "Equinox Markets",
    // API_URL:"https://cmsapi.equinoxmarkets.com",
    // SERVER_URL:"https://cmsapi.equinoxmarkets.com",
    // MEDIA_URL:"https://cmsapi.equinoxmarkets.com/media/",
    // LOGO: logo7,
    // LOGO_CLASSNAME: "equinox-logo",

    // brandName: "Equinox Markets",
    // API_URL:"https://cmsapi.equinox-markets.com",
    // SERVER_URL:"https://cmsapi.equinox-markets.com",
    // MEDIA_URL:"https://cmsapi.equinox-markets.com/media/",
    // LOGO: logo7,
    // LOGO_CLASSNAME: "equinox-logo",

    // brandName: "Excotrades",
    // API_URL:"https://cmsapi.excotrades.com",
    // SERVER_URL:"https://cmsapi.excotrades.com",
    // MEDIA_URL:"https://cmsapi.excotrades.com/media/",
    // LOGO: logo8,
    // LOGO_CLASSNAME: "excotrades-logo",

    // brandName: "Minos Test",
    // API_URL:"",
    // SERVER_URL:"http://localhost:5000",
    // MEDIA_URL:"http://localhost:5000/media/",
    // LOGO: logo2,
    // LOGO_CLASSNAME: "minos-logo",
};

export default Keys;

